'use strict';
var base = require('./base');
var baseDetail = require('base/product/detail');
var baseWishlist = require('wishList/product/wishlist');

function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}


function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text() || $(this).data('pid'),
            quantity: parseInt($(this).find('.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="' + data.maxBonusItems + '"' +
        'data-UUID="' + data.uuid + '"' +
        'data-pliUUID="' + data.pliUUID + '"' +
        'data-addToCartUrl="' + data.addToCartUrl + '"' +
        'data-pageStart="0"' +
        'data-pageSize="' + data.pageSize + '"' +
        'data-moreURL="' + data.showProductsUrlRuleBased + '"' +
        'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <span class="">' + data.labels.selectprods + '</span>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
            response.message +
            '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

baseDetail.updateAttributesAndDetails = function () {
    $('body').on('product:statusUpdate', function (e, data) {
        //updates product name and brand
        if ($('.product-detail .product-name').length) {
            $('.product-name').text(data.productName);
        }
        if ($('.product-detail .brand-name').length) {
            $('.brand-name').text(data.brand);
        }

        var $productContainer = $('.product-detail');

        $productContainer.find('.description-and-detail .product-attributes')
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .content')
                .empty()
                .html(data.shortDescription);
        } else {
            $productContainer.find('.description-and-detail .description')
                .addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content')
                .empty()
                .html(data.longDescription);
        } else {
            $productContainer.find('.description-and-detail .details')
                .addClass('hidden-xl-down');
        }
        // Only for custom PDP tabs
        if ($('.description-and-detail .product-custom-attributes').length > 0 && data.customCategoryTabHtml) {
            $('.description-and-detail .product-custom-attributes').remove();
            $(".description-and-detail #myTabContent").append(data.customCategoryTabHtml);
        } else if (data.customCategoryTabHtml) {
            $productContainer.find('#myTabContent').append(data.customCategoryTabHtml);
        } else if ($('.description-and-detail .product-custom-attributes').length > 0) {
            $('.description-and-detail .product-custom-attributes').remove();
        }

        // Only for custom PDP tab ID
        if ($('.description-and-detail .custom-product-tab-li').length > 0 && data.customCategoryTabIDHtml) {
            $('.description-and-detail .custom-product-tab-li').remove();
            $(".description-and-detail #myTab").append(data.customCategoryTabIDHtml);
            $(".description-and-detail #myTab li:first a").trigger("click");
        } else if (data.customCategoryTabIDHtml) {
            $productContainer.find('#myTab').append(data.customCategoryTabIDHtml);
            $(".description-and-detail #myTab li:first a").trigger("click");
        } else if ($('.description-and-detail .custom-product-tab-li').length > 0) {
            $('.description-and-detail .custom-product-tab-li').remove();
            $(".description-and-detail #myTab li:first a").trigger("click");
        }
    });

    // Thumbnail refresh after ajax update
    $('body').on('product:afterAttributeSelect', function () {
        setTimeout(function () {
            $(document).find('.product-thumbnail-slick').slick('refresh');
        }, 1000);
    });
};

// avoid spinner on quantity update, removed product:beforeAttributeSelect from base
baseDetail.showSpinner = function () {
    $('body').on('product:beforeAddToCart', function () {
        $.spinner().start();
    });
};

baseDetail.productZoom = function () {
    if ($(window).width() > 1024) {
        $('.easyzoom').easyZoom();
    }
};


baseDetail.availability = function () {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            base.attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                $productContainer);
        }
    });
};

baseDetail.addToCart = function () {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var storeId = null;
        //only added this storeID for BOPIS. If storeID is null it will work as norml flow.

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = base.getPidValue($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }
        if ($('#delivery-options-store').prop('checked') == true) {
            storeId = $('.selected-store-address').attr('data-store-id');
        }

        addToCartUrl = getAddToCartUrl();

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            storeId: storeId,
            childProducts: getChildProducts(),
            quantity: base.getQuantitySelected($(this))
        };
        if (window.resources.preferences.listrakCartridgeEnabled == 'true') {
            form.format = 'ajax';
        }

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data); // function is not exported from base
                    $('body').trigger('product:afterAddToCart', data);
                    if (!data.error) {
                        let requestBody = {
                            pid: pid,
                            quantity: base.getQuantitySelected($(this))
                        }
                        $(function () {
                            var event = new CustomEvent('triplewhale:add-to-cart', {
                                detail: requestBody
                            });
                            document.dispatchEvent(event);
                        });
                    }
                    $.spinner().stop();
                    base.miniCartReportingUrl(data.reportingURL);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

baseDetail.addToWishlist = function () {
    $('.add-to-wish-list').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var pid = $(this).closest('.product-detail').find('.product-id').html();
        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                if (data.wishlistCount >= 0) {
                    $('.wishlist span.wishlistCount').html(data.wishlistCount);
                }
                displayMessage(data, button);

                if (window.resources.preferences.isGTMEnabled) {
                    $('body').trigger('gtm:addToWishlist');
                }
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};

baseDetail.youtubeModal = function () {
    $('body').on('click', '.youtube-video-modal', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        $('#youtubeModal').modal('show');
        $('#youtubeModal .modal-body').html('<iframe src="'+ url +'" title="YouTube video player" width="640" height="520" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    });

    $('#youtubeModal').on('hidden.bs.modal', function () {
        $('#youtubeModal .modal-body').empty();
    });
}

module.exports = baseDetail;
